import { STORE_STATUS } from "../../../commons/constants/store";
import styles from "./store-card.module.scss";

interface props {
  storeId: string;
  status: STORE_STATUS;
  handleOffStore: (storeId: string) => void;
  handleOpenStore: (storeId: string) => void;
  handleCloseStore: (storeId: string) => void;
  handleToggleThreshold: (storeId: string, auto: boolean) => void;
  isAutoThresholdEnabled?: boolean;
  isTerminalEnabled?: boolean;
}

const PopupStatusMember = ({ status, storeId, handleCloseStore, handleOpenStore }: props) => {
  if (status === STORE_STATUS.LIVE) {
    return (
      <div className={styles.btnActionMember}>
        <p
          onClick={e => {
            e.stopPropagation();
            handleCloseStore(storeId);
          }}
        >
          Close
        </p>
      </div>
    );
  } else if (status === STORE_STATUS.SUSPENDED) {
    return null;
  } else {
    return null;
    // return (
    //   <div className={styles.btnActionMember}>
    //     <p
    //       onClick={e => {
    //         e.stopPropagation();
    //         handleOpenStore(storeId);
    //       }}
    //     >
    //       Open
    //     </p>
    //   </div>
    // );
  }
};

export default PopupStatusMember;
